import React, {useEffect, useState} from 'react';
import {SosMap} from './components/SosMap';
import {PageHeader} from '../../../components/common/pageHeader/PageHeader';
import {useQuery} from "react-query";
import {getSosRequestById} from "../../../services/sosSvc";
import {useParams} from "react-router-dom";
import moment from "moment";
import {ISosPosition} from "../../../types/sos";
import {MyTooltip} from "../../../components/common/tooltip/Tooltip";
import {getAuth} from "../../../modules/auth";
import {LoaderSection} from "../../../components/sections/loader/Loader";
import {EmptySection} from "../../../components/sections/empty/Empty";
import imgBaseUrl from "../../../utils/imgBaseUrl";
import {PLACEHOLDER_IMAGE_URL} from "../../../mock/constants";
import {getUserById} from "../../../services/userSvc";
import {API_HOSTNAME_URL} from "../../../mock/URLs";

export const SosViewPage = () => {
  const {userId} = useParams();
  const {data: userData} = useQuery("", () => getUserById(Number(userId!)));

  const {
    data: sosByIdData,
    isLoading: sosByIdIsLoading
  } = useQuery<ISosPosition[]>("getSosRequestById", async () => {
    const data = await getSosRequestById(Number(userId!), {
      params: {
        page_size: 20
      }
    });
    return Array.isArray(data) ? data : [data];
  });

  const pageDetails = {
    title: 'Kuzatuv',
    desc: `Kuzatiluvchi - ${userData?.first_name} ${userData?.last_name}`,
  };

  const [selectedLocation, setSelectedLocation] = useState<ISosPosition | null>(null);
  const [messages, setMessages] = useState<ISosPosition[]>([]);
  const [socket, setSocket] = useState<WebSocket | null>(null);
  const [isConnecting, setIsConnecting] = useState(false);

  const connectToVictimWs = () => {
    setIsConnecting(true);
    const wsUrl = `wss://${API_HOSTNAME_URL}/ws/help/${userId}/?token=${getAuth()?.access}`;
    const ws = new WebSocket(wsUrl);
    setSocket(ws);

    ws.onopen = () => {
      setIsConnecting(false);
    };

    ws.onmessage = (event: MessageEvent) => {
      setMessages((prevMessages) => {
        const newMessage = JSON.parse(event.data)?.type === "send_help" ? JSON.parse(event.data) : [];
        return Array.isArray(newMessage) ? [...newMessage, ...prevMessages] : [newMessage, ...prevMessages];
      });
    };

    ws.onerror = () => {
      setIsConnecting(false);
    };

    ws.onclose = () => {
      setIsConnecting(false);
    };
  }

  useEffect(() => {
    if (sosByIdData && sosByIdData.length > 0) {
      setSelectedLocation(sosByIdData[0]);
      setMessages(sosByIdData);
    }
  }, [sosByIdData]);

  useEffect(() => {
    setSelectedLocation(messages[0]);
  }, [messages]);

  return (
      <div>
        <PageHeader pageDetails={pageDetails}/>
        {(sosByIdIsLoading || sosByIdIsLoading) ? <LoaderSection height={"50vh"}/> : sosByIdData?.length === 0 ?
            <EmptySection height={"50vh"}/> : <div className="mt-5 h-100">
              <div className="row h-100">
                <div className="col-md-9">
                  {selectedLocation && (
                      <SosMap height={'80vh'} locations={messages}
                              initialCenter={[selectedLocation.latitude, selectedLocation.longitude]}/>
                  )}
                </div>
                <div className="col-md-3 flex-grow-1 d-flex flex-column">
                  <div className="card p-3 h-100 rounded-4">
                    <div className="d-flex align-items-center gap-3">
                      <img
                          className="symbol object-fit-cover rounded"
                          src={imgBaseUrl(userData?.avatar!) || PLACEHOLDER_IMAGE_URL}
                          alt={`${userData?.first_name} ${userData?.last_name}`}
                          style={{width: '60px', height: '60px'}}
                      />
                      <div className="d-flex flex-column">
                              <span
                                  className="fw-bold fs-5">{userData?.first_name} {userData?.last_name}</span>
                        <span className="text-muted fs-7">{userData?.role?.toUpperCase()}</span>
                      </div>
                    </div>

                    <div className="mt-4">
                      <div className="d-flex justify-content-between border-bottom py-2">
                        <span className="fw-bold">Vaqt:</span>
                        <span>{moment(selectedLocation?.created_at).format("DD.MM.YYYY HH:mm:ssss")}</span>
                      </div>
                      <div className="d-flex justify-content-between border-bottom py-2">
                        <span className="fw-bold">Holat:</span>
                        {
                          sosByIdData && sosByIdData[0]?.status === 'DANGER' ?
                              <span className="badge badge-light-danger fs-8 fw-bold">Xavfli hududda</span> :
                              <span className="badge badge-light-primary fs-8 fw-bold">Xavfsiz hududda</span>
                        }
                      </div>

                      <div className="d-flex justify-content-between border-bottom py-2">
                        <span className="fw-bold">Manzil:</span>
                        <MyTooltip title={"Yandexda ochish"} position={"top"}>
                          <a rel={"noreferrer"} target={"_blank"}
                             href={`https://yandex.com/maps/?ll=${selectedLocation?.longitude},${selectedLocation?.latitude}&z=20&pt=${selectedLocation?.longitude},${selectedLocation?.latitude}`}
                             className={"text-end text-hover-primary text-muted fs-8 fw-bold"}>{selectedLocation?.latitude} {selectedLocation?.longitude}</a>
                        </MyTooltip>
                      </div>
                    </div>
                    <div className="mt-4 flex-grow-1 d-flex flex-column">
                      <div className={"d-flex mb-5 align-items-center justify-content-between"}>
                        <h6 className="fw-bold mb-0">Manzil Tarixi:</h6>
                        <button disabled={socket?.readyState === WebSocket.OPEN} onClick={() => connectToVictimWs()}
                                className={"btn btn-sm btn-primary"}>
                          {isConnecting ? "Bog'lanyapti..." : (socket?.readyState === WebSocket.OPEN ? "Bog'landi" : "Jonli kuzatish")}
                        </button>
                      </div>
                      <div className="p-3 border rounded-4 flex-grow-1" style={{maxHeight: '54vh', overflowY: 'auto'}}>
                        <ul className="list-unstyled mb-0">
                          {messages?.map((sosItem, index) => (
                              <li
                                  onClick={() => setSelectedLocation(sosItem)}
                                  key={index}
                                  className="text-hover-primary cursor-pointer d-flex justify-content-between py-1"
                              >
                                <span className={"d-block"}>{sosItem?.latitude} {sosItem?.longitude}</span>
                                <span
                                    className="d-block text-muted text-end fs-7">{moment(sosItem?.created_at).format("DD.MM.YYYY HH:mm:ss")}</span>
                              </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>}
      </div>
  );
};